@for (key of errors; track key) {
  <p>
    <small class="text-red-500">{{ ERROR_MESSAGES[key] }}</small>
  </p>
}